declare var Waypoint: any;

function abbrNum(num: number) {
  let newNum = num;
  const decPlaces = (10 ** 0);
  const abbrev = ['K', 'M', 'B', 'T'];

  for (let i = abbrev.length - 1; i >= 0; i -= 1) {
    const size = (10 ** ((i + 1) * 3));
    if (size <= num) {
      newNum = Math.round(newNum * decPlaces / size) / decPlaces;

      if ((newNum === 1000) && (i < abbrev.length - 1)) {
        newNum = 1;
        i += 1;
      }

      newNum += abbrev[i];

      break;
    }
  }
  return newNum;
}

function commaSeparateNum(num) {
  const numParts = num.toString().split('.');
  numParts[0] = numParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return numParts.join('.');
}

// eslint-disable-next-line no-plusplus, no-param-reassign
const ease = t => 1 + (--t) * t * t * t * t;
const frameDuration = 1000 / 60;

function countUp(number, frames) {
  let frame = frames;
  let { speed } = number.dataset;
  let { target } = number.dataset;
  let { counter } = number.dataset;

  speed = parseInt(speed);
  target = parseInt(target);
  counter = parseInt(counter);

  const totalFrames = Math.round(speed / frameDuration);

  if (counter < target) {
    frame += 1;
    const progress = ease(frame / totalFrames);
    const countStep = Math.round(target * progress);

    if (countStep >= 100000000) {
      number.innerText = abbrNum(countStep).toString();
    } else {
      number.innerText = commaSeparateNum(countStep);
    }
    number.dataset.counter = countStep.toString();
    window.requestAnimationFrame(() => { countUp(number, frame); });
  } else {
    if (target >= 100000000) {
      number.innerText = abbrNum(target).toString();
    } else {
      number.innerText = commaSeparateNum(target);
    }
    number.dataset.counter = target.toString();
    window.cancelAnimationFrame(countUp);
  }
}

function initNumStats(el: HTMLElement) {
  const number = el.querySelector('.stats-number');
  if (!(number instanceof HTMLElement)) {
    return;
  }

  // Count up when statistic is in viewport
  // eslint-disable-next-line no-unused-vars
  const waypointDown = new Waypoint({
    element: el,
    offset: '90%',
    handler: (direction: string) => {
      if (direction === 'down') {
        countUp(number, 0);
      }
    },
  });
}

const numStats:Array<HTMLDivElement> = Array.from(document.querySelectorAll('.js-num-stat'));
numStats.forEach(initNumStats);
